import { Injectable } from '@angular/core';
import { TableauAuthService } from '@app/reports/tableau/tableau-auth.service';
import { DbService } from './db.service';
import { SessionStorage } from './session-storage';
import { ServiceWorkerService } from './sw.service';

@Injectable({ providedIn: 'root' })
export class StorageManager {
  constructor(
    private db: DbService,
    private sessionStorage: SessionStorage,
    private tableauService: TableauAuthService,
    private serviceWorkerService: ServiceWorkerService,
  ) {}

  public async clearLocalStorage(): Promise<boolean> {
    return Promise.all([
      this.db.flushTravelGroups(),
      this.db.flushTravelGroupsLocations(),
      this.serviceWorkerService.clearCacheStorage(),
    ]).then(() => {
      this.sessionStorage.removeCookie();
      this.tableauService.invalidateTimeoutCookie();
      return Promise.resolve(true);
    });
  }
}
